import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const Season = ({ handleClick, isActive, display_name }) => (
  <div onClick={handleClick}
    className={classNames('season', { 'active': isActive })}
    dangerouslySetInnerHTML={{ __html: display_name }}
  />
);

Season.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  display_name: PropTypes.string.isRequired
};

export default Season;
